var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOppS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2B5770",
    fillRule: "nonzero",
    width: 32,
    height: 32,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.705 23.667l-.004.092a2.352 2.352 0 01-.162.722 2.328 2.328 0 01-.475.738l-.016.017-.063.062.079-.08a2.365 2.365 0 01-.812.555 2.543 2.543 0 01-.372.116 1.746 1.746 0 01-.242.04 3.03 3.03 0 01-.265.016l.094-.002-.058.001h-.036a2.379 2.379 0 01-.317-.02l-.11-.018a2.332 2.332 0 01-.318-.083l-.022-.007a2.318 2.318 0 01-.387-.176l-.032-.019a1.918 1.918 0 01-.182-.119 2.475 2.475 0 01-.11-.084l-.021-.018a2.347 2.347 0 01-.094-.084l-.015-.013-6.069-5.767-.112-.114a2.324 2.324 0 01-.604-1.371 2.307 2.307 0 01-.603 1.365l-.112.114-6.069 5.767-.097.088-.054.044a2.42 2.42 0 01-.546.326 2.185 2.185 0 01-.394.127 1.778 1.778 0 01-.21.037 2.505 2.505 0 01-.306.02h-.034l-.003-.001-.075-.001H7.5a1.77 1.77 0 01-.265-.025 3.544 3.544 0 01-.222-.045 1.97 1.97 0 01-.302-.099 2.258 2.258 0 01-.35-.179l-.07-.044-.01-.007a2.343 2.343 0 01-.258-.203l-.087-.083-.037-.039-.028-.03-.017-.019-.024-.026a2.355 2.355 0 01-.422-.705 2.31 2.31 0 01-.144-.64l-.003-.04-.004-.147V8.718a2.333 2.333 0 014.662-.147l.004.147v9.451l2.129-2.022a2.333 2.333 0 013.93 1.481 2.334 2.334 0 013.799-1.59l.131.115 2.128 2.021v-9.45l.005-.148a2.333 2.333 0 014.662.148v14.943z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOppS);
export default __webpack_public_path__ + "static/assets/logo_opp_s.8b7d6a23.svg";
export { ForwardRef as ReactComponent };